import { render, staticRenderFns } from "./MekkeDetail.vue?vue&type=template&id=70c67096"
import script from "./MekkeDetail.vue?vue&type=script&lang=js"
export * from "./MekkeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports